import {Storage} from '../lib/storage/Storage'

// NOTE: This class exists for documentation purposes at the moment

/**
 * Interface for handling settings and properties stored in localStorage
 * @alias api.settings
 *
 * @class
 */
class Settings extends Storage {

    /**
     * Get a value for a specific setting. Return null, or default value when specified
     * when not existing.
     *
     * @param {String} namespace - Plugin name, or namespace of saved setting value
     * @param {String} key - Key where setting is saved
     * @param {*} [defaultValue=`null`] - Default return value if key is not found in namespace
     *
     * @returns {*}
     */
    get(namespace, key, defaultValue = null) {
        return super.get(namespace, key, defaultValue)
    }

    /**
     * Set a value for a specific setting, transformed into JSON. Returns
     * true on success, false on failure.
     *
     * @param {String} namespace - Plugin name or custom namespace where to save setting
     * @param {String} key - Which key to use to save setting value
     * @param {*} value - Value of setting
     *
     * @returns {boolean}
     */
    set(namespace, key, value) {
        return super.set(namespace, key, value)
    }

    /**
     * Delete a specific setting. Returns true on success, false on failure.
     *
     * @param {String} namespace
     * @param {String} key
     *
     * @returns {boolean}
     */
    delete(namespace, key) {
        return super.delete(namespace, key)
    }

    /**
     * Retrieve all settings stored. Returns false on failure, object on success.
     *
     * @param {String} namespace - Plugin name or custom namespace where to save setting
     *
     * @returns {*}
     */
    getAllSettings(namespace) {
        return super.getAllSettings(namespace)
    }
}

export {Settings}
